exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content[data-v-153822e9] {\n  padding: 0 15px;\n}\n.paragraph[data-v-153822e9] {\n  margin-bottom: 5px;\n  min-height: 6px;\n  word-break: break-all;\n  line-height: 1.5;\n}\n.paragraph[data-v-153822e9]:last-child {\n    margin-bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-153822e9","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/template/writing.vue
// module id = 1239
// module chunks = 0